module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top-buffer bottom-buffer"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('label', {
    staticClass: "inline",
    attrs: {
      "id": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), (_vm.help_text) ? [_c('HelpText', {
    attrs: {
      "help_text": _vm.help_text
    }
  })] : _vm._e(), _vm._v(" "), (_vm.help_text_url) ? [_c('HelpTextUrl', {
    attrs: {
      "help_text_url": _vm.help_text_url
    }
  })] : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "collapse-link-top pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.expand($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "children-anchor-point collapse in",
    staticStyle: {
      "padding-left": "0px"
    }
  }), _vm._v(" "), (_vm.isPreviewMode) ? _c('span', {
    class: {
      'hidden': _vm.isRemovable
    }
  }, [_c('a', {
    attrs: {
      "id": 'remove_' + _vm.name
    }
  }, [_vm._v("Remove " + _vm._s(_vm.label))])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "collapse-link-bottom pull-right",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.minimize($event)
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-up"
  })]), _vm._v(" "), _c('div', {
    class: {
      'row': true, 'collapse': true, 'in': _vm.isExpanded
    },
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._t("default")], 2)])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-601ba201"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/group.vue
// module id = 989
// module chunks = 0